<template>
  <section class="itinerary_description__container">
    <div
      v-if="!hideElementByCondition"
      class="mb-5 w-100 is-flex updateItineraryButton"
    ></div>
    <div class="card">
      <div class="card-content">
        <div v-if="info && info.itinerary">
          <div
            v-if="disableQuoteByStatus"
            v-html="form.terms_and_conditions"
          ></div>
          <vue-editor v-else v-model="form.terms_and_conditions" />
        </div>
        <footer class="card-footer pr-0">
          <div class="card-footer-item is-justify-content-flex-end pb-0">
            <BaseButton
              size="medium"
              data-action-type="ITINERARY:DESCRIPTION_SAVE"
              action="tercery"
              :loading="isSaving"
              :disabled="disableQuoteByStatus"
              @click="saveEdit"
            >
              <i slot="icon" class="mr-4 ml-1">
                <IconCheck class="icon is-small" />
              </i>
              <p slot="text">Save</p>
            </BaseButton>
          </div>
        </footer>
      </div>
    </div>
  </section>
</template>

<script>
import { VueEditor } from "vue2-editor";
import { mapGetters } from "vuex";
import helpers from "@/helpers";
import IconChatGpt from "@/components/icons/IconChatGpt.vue";
import ItineraryDescriptionAutocompleteModal from "@/components/quote-views/itinerary/ItineraryDescriptionAutocompleteModal.vue";
import { FEATURE_NAME } from "@/constants";
import BaseButton from "@/components/base-ui/BaseButton.vue";
import IconCheck from "@/components/icons/IconCheck.vue";
import { openToast } from "@/utils/utils";

export default {
  name: "ItineraryTermCondition",
  components: {
    IconCheck,
    BaseButton,
    ItineraryDescriptionAutocompleteModal,
    IconChatGpt,
    VueEditor,
  },
  data() {
    return {
      featureName: FEATURE_NAME,
      isLoading: false,
      isSaving: false,
      isEditing: false,
      form: {
        terms_and_conditions: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      getItinerary: "itinerary/getItinerary",
      disableQuoteByStatus: "itinerary/getDisableQuoteByStatus",
      itineraryStatus: "itinerary/getItineraryStatus",
      itineraryDays: "itineraryDays/getItineraryDays",
      formItinerary: "itinerary/getFormItinerary",
      hideElementByCondition: "itinerary/getHideElementByCondition",
    }),
    info() {
      return {
        itinerary: this.getItinerary.data,
      };
    },
  },
  props: {
    setLoading: {
      type: Function,
      default: () => {},
    },
    loadItinerary: {
      type: Function,
      default: () => {},
    },
  },
  watch: {
    formItinerary(newForm) {
      this.form.terms_and_conditions = newForm[0].terms_and_conditions.value;
    },
  },
  activated() {
    this.form.terms_and_conditions =
      this.formItinerary[0].terms_and_conditions.value;
  },
  methods: {
    async saveEdit() {
      if (this.isSaving) {
        return false;
      }
      const itinerary = this.info.itinerary;

      this.isLoading = true;
      this.isSaving = true;

      helpers.applyTranslation(
        itinerary.language.language_code,
        this.formItinerary[0].terms_and_conditions,
        this.form.terms_and_conditions
      );

      await this.$store
        .dispatch("itinerary/update", {
          ...this.formItinerary[0],
          cur_step: 1,
          last_step: 1,
        })
        .then(() => {
          openToast(this.$buefy, "T&C saved successfully!", "is-success");

          this.isLoading = false;
          this.isSaving = false;
          this.loadItinerary();
        })
        .catch((error) => {
          this.isLoading = false;
          this.isSaving = false;
          throw error;
        });
    },
  },
};
</script>
<style scoped>
.updateItineraryButton {
  justify-content: flex-end;
}
.itinerary_description__container .card {
  background-color: var(--quote-bg-color);
}
@media screen and (max-width: 480px) {
  .modules__container {
    display: none;
  }
  .updateItineraryButton {
    margin-bottom: 0rem !important;
  }
}
</style>
